import React, { useLayoutEffect, useRef, useState } from 'react';
import { defaultTo } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import { Components } from '@fasstech/flexiget';
import RichTooltip from './RichTooltip';

const EllipsisTooltip = ({
  text,
  textClassName = '',
  tooltipClassName = '',
  innerStyle = {},
  forceBreakWords = false,
  title,
  children
}) => {
  const elementRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const safeText = defaultTo('', text);

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    const syncTooltipVisibilityWithTruncation = () => {
      setShowTooltip(element.scrollWidth - element.clientWidth > 1);
    };

    syncTooltipVisibilityWithTruncation();

    let truncationResizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      truncationResizeObserver = new ResizeObserver(syncTooltipVisibilityWithTruncation);
      truncationResizeObserver.observe(element);
      if (element.parentElement) truncationResizeObserver.observe(element.parentElement);
    }

    window.addEventListener('resize', syncTooltipVisibilityWithTruncation);
    return () => {
      if (truncationResizeObserver) truncationResizeObserver.disconnect();
      window.removeEventListener('resize', syncTooltipVisibilityWithTruncation);
    };
  }, [safeText]);

  const shouldUseRichPath = isNotNilOrEmpty(title);

  const triggerSpan = (
    <span ref={elementRef} className={`block w-full truncate ${textClassName}`}>
      {safeText}{children}
    </span>
  );

  if (shouldUseRichPath) {
    return (
      <RichTooltip title={title} className={tooltipClassName} innerStyle={innerStyle}>
        {triggerSpan}
      </RichTooltip>
    );
  }

  const tooltipTitle = forceBreakWords
    ? <span className="break-all [overflow-wrap:anywhere]">{safeText}</span>
    : safeText;

  return (
    <Components.Tooltip title={showTooltip ? tooltipTitle : null} className={tooltipClassName}>
      {triggerSpan}
    </Components.Tooltip>
  );
};

export default EllipsisTooltip;
